export const PUBLIC_BANQUET_STATUSES = ["approved", "published"];

export const isPubliclyVisibleBanquet = (banquet) => {
  if (!banquet) {
    return false;
  }

  if (!banquet.status) {
    return banquet.isActive !== false;
  }

  return banquet.isActive !== false && PUBLIC_BANQUET_STATUSES.includes(banquet.status);
};
